import { DUPLICATE_CANONICAL_TARGET_LABEL } from "./constants";
import { getProvenanceLabel } from "./getProvenanceLabel";

/**
 * The label shown for how a mapping was arrived at. A duplicate-target collision
 * is a real error that takes priority; otherwise it is the provenance word
 * ("Reused" | "AI Reused" | "AI Generated"), or "—" when there is none.
 */
export function getMlSuggestedStatusLabel(
  mapping: Record<string, unknown>,
): string {
  if (mapping.duplicateCanonicalPath === true) {
    return DUPLICATE_CANONICAL_TARGET_LABEL;
  }

  return (
    getProvenanceLabel(mapping.provenance as string | null | undefined) ?? "—"
  );
}
